import { IconDefinition } from '@fortawesome/fontawesome-svg-core'

const fileSearchIcon: IconDefinition = {
  prefix: 'fas',
  iconName: 'file-search',
  icon: [
    19,
    22,
    [],
    '',
    [
      'M11.0605 9.2207C13.901 9.2207 16.243 11.4231 16.2432 14.0947C16.2432 15.1727 15.8699 16.1807 15.2471 16.9775L18.3867 19.9541C18.7103 20.2353 18.7104 20.7276 18.3867 21.0088C18.0877 21.3135 17.5637 21.3135 17.2646 21.0088L14.1006 18.0322C13.2534 18.6416 12.1818 18.9697 11.0605 18.9697C8.19515 18.9697 5.87793 16.7898 5.87793 14.0947C5.87793 14.0631 5.88021 14.0315 5.88086 14H5.87793C5.89836 12.2791 6.68625 11.1537 7.66309 10.4199C8.42821 9.79255 9.3904 9.37258 10.4512 9.25488C10.4677 9.25222 10.4839 9.24951 10.5 9.24707V9.24902C10.6841 9.23026 10.8711 9.22071 11.0605 9.2207ZM11.0605 10.7197C10.8697 10.7197 10.6825 10.7339 10.5 10.7607V12.6875C10.4999 13.4257 9.8984 14 9.1875 14H7.47559C7.47466 14.0315 7.47266 14.063 7.47266 14.0947C7.47266 15.9696 9.06724 17.4697 11.0605 17.4697C13.029 17.4697 14.6484 15.9696 14.6484 14.0947C14.6483 12.2434 13.0289 10.7197 11.0605 10.7197Z',
      'M6.125 3.5C6.12506 3.99197 6.50808 4.37475 7 4.375H10.5V8.23926C9.82501 8.32313 8.8303 8.57734 7.86523 9.10645C7.82061 8.91781 7.62909 8.75 7.4375 8.75H3.0625C2.81664 8.75028 2.625 8.96889 2.625 9.1875C2.62506 9.43337 2.81668 9.62475 3.0625 9.625H7.05957C6.72786 9.87487 6.41262 10.1654 6.12891 10.5H3.0625C2.81664 10.5003 2.625 10.7189 2.625 10.9375C2.62506 11.1834 2.81668 11.3748 3.0625 11.375H5.52637C5.13527 12.0936 4.88838 12.9604 4.87793 14H1.3125C0.574489 13.9998 6.07844e-05 13.4256 0 12.6875V1.3125C0 0.601716 0.57445 0.000260791 1.3125 0H6.125V3.5ZM3.0625 7C2.81664 7.00028 2.625 7.21889 2.625 7.4375C2.62506 7.68337 2.81668 7.87475 3.0625 7.875H7.4375C7.65622 7.875 7.87493 7.68353 7.875 7.4375C7.875 7.21875 7.65625 7 7.4375 7H3.0625Z',
      'M10.5 3.5H7V0L10.5 3.5Z'
    ].join(' ')
  ]
}

const sortDownCentered: IconDefinition = {
  prefix: 'fasr',
  iconName: 'sort-down',
  icon: [
    17,
    19.55,
    [],
    '',
    [
      'M8.5 13.43',
      'c-0.465 0-0.93-0.478-1.284-0.532',
      'L2.468 8.15',
      'c-0.342-0.342-0.442-0.85-0.256-1.296',
      'c0.186-0.446 0.62-0.736 1.1-0.736',
      'h10.376',
      'c0.48 0 0.914 0.29 1.1 0.736',
      'c0.186 0.446 0.086 0.954-0.256 1.296',
      'l-4.748 4.748',
      'C9.43 13.25 8.97 13.43 8.5 13.43z'
    ].join('')
  ]
}

const fortawesomeConfig = [fileSearchIcon, sortDownCentered]

export default fortawesomeConfig
